<template>
    <div id="chat-app" class="border border-solid d-theme-border-grey-light rounded relative overflow-hidden">
        <vs-sidebar class="items-no-padding" parent="#chat-app" :click-not-close="clickNotClose" :hidden-background="clickNotClose" v-model="isChatSidebarActive" id="chat-list-sidebar">
            <div class="chat__profile-search flex p-4">
                <div class="relative inline-flex">
                    <vs-avatar v-if="user.image" class="m-0 border-2 border-solid border-white" :src="user.image" size="40px" @click="viewProfile(user.id)" />
<!--                    <div class="h-3 w-3 border-white border border-solid rounded-full absolute right-0 bottom-0" :class="'bg-' + getStatusColor(true)"></div>-->
                </div>
                <vs-input icon-no-border icon="icon-search" icon-pack="feather" class="w-full mx-5 input-rounded-full" placeholder="ابحث عن محادثة" v-model="searchQuery"/>

                <feather-icon class="md:inline-flex lg:hidden -ml-3 cursor-pointer" icon="XIcon" @click="toggleChatSidebar(false)" />
            </div>
            <vs-divider class="d-theme-border-grey-light m-0" />
            <VuePerfectScrollbar class="chat-scroll-area pt-4" :settings="settings" :key="$vs.rtl">
                <!-- ACTIVE CHATS LIST -->
                <div class="chat__chats-list mb-8">
                    <h3 class="text-primary mb-5 px-4">المحادثات</h3>
                    <ul class="chat__active-chats bordered-items">
                        <li class="cursor-pointer" v-for="(contact, index) in chatContacts" :key="index" @click="updateActiveChatUser(contact.id)">
                            <chat-contact :showLastMsg="!!chatLastMessaged(contact.id)" :contact="contact" :lastMessaged="chatLastMessaged(contact.id) ? chatLastMessaged(contact.id).time : null" :unseenMsg="chatUnseenMessages(contact.id)" :isActiveChatUser="isActiveChatUser(contact.id)"></chat-contact>
                        </li>
                    </ul>
                </div>
            </VuePerfectScrollbar>
        </vs-sidebar>

        <!-- RIGHT COLUMN -->
        <div class="chat__bg no-scroll-content chat-content-area border border-solid d-theme-border-grey-light border-t-0 border-r-0 border-b-0" :class="{'sidebar-spacer--wide': clickNotClose}">
          <div class="chat__navbar">
            <chat-navbar :isSidebarCollapsed="!clickNotClose" :user-id="activeChatUser" :isPinnedProp="isChatPinned" @openContactsSidebar="toggleChatSidebar(true)" @toggleIsChatPinned="toggleIsChatPinned"></chat-navbar>
          </div>
            <template>
                <VuePerfectScrollbar class="chat-content-scroll-area select-none border border-solid d-theme-border-grey-light" :settings="settings" ref="chatLogPS" :key="$vs.rtl">
                  <div class="chat__log" ref="chatLog" :class="{'flex items-center justify-center': activeChatUser === null}">
<!--                  <div @click="setInputFocus" class="chat__log" ref="chatLog">-->
                    <template v-if="activeChatUser">
                      <infinite-loading forceUseInfiniteWrapper=".chat-content-scroll-area" :key="activeChatUser"
                                        spinner="spiral" direction="top"
                                        @infinite="loadMoreMessages">
                        <span slot="no-more"></span>
                        <span slot="no-results"></span>
                      </infinite-loading>
                      <chat-log :userId="activeChatUser" :prevent-scroll-down="preventChatLogScroll" @resend="resendMsg" v-if="activeChatUser"></chat-log>
                    </template>
                    <template v-else>
                        <div class="flex flex-col items-center justify-center">
                            <feather-icon icon="MessageCircleIcon" class="mb-4 bg-white p-8 shadow-md rounded-full" svgClasses="w-16 h-16"></feather-icon>
                            <div class="py-2 px-4 bg-white shadow-md rounded-lg mx-4">
<!--                              <h4 class="text-center mb-2" @click.stop="toggleChatSidebar(true)">إبدأ محادثة</h4>-->
                              <h4>لبدء محادثه جديدة اضغط على زر "الرسائل" من الصفحة الشخصية للشخص لبدء المحادثة معه.</h4>
                            </div>
                        </div>
                    </template>
                  </div>
                </VuePerfectScrollbar>
                <div v-if="activeChatUser" class="chat__input flex p-4 bg-white">
                    <vs-input ref="msgInput" autofocus class="flex-1" placeholder="أكتب رسالتك" v-model="typedMessage" @keyup.enter="sendMsg" />
                    <vs-button class="bg-primary-gradient ml-4" type="filled" @click="sendMsg">إرسال</vs-button>
                </div>
            </template>

        </div>
    </div>
</template>

<script>
import ChatContact         from "./ChatContact.vue"
import ChatLog             from './ChatLog.vue'
import ChatNavbar          from './ChatNavbar.vue'
import UserProfile         from "./UserProfile.vue"
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import InfiniteLoading     from 'vue-infinite-loading'

export default {
  data() {
    return {
      active               : true,
      isHidden             : false,
      searchContact        : "",
      activeProfileSidebar : false,
      userProfileId        : -1,
      typedMessage         : "",
      isChatPinned         : false,
      settings             : {
        maxScrollbarLength : 60,
        wheelSpeed         : 0.70,
        wheelPropagation   : true,
      },
      clickNotClose        : true,
      isChatSidebarActive  : true,
      isLoggedInUserProfileView: false,
      preventChatLogScroll: false,
    }
  },
  watch: {
    windowWidth() {
      this.setSidebarWidth()
    }
  },
  computed: {
    activeChatUser: {
        get() {return this.$store.state.chat.activeChatUser},
        set(val) {this.$store.commit('chat/SET_ACTIVE_CHAT_USER', val)}
    },
    chatLastMessaged() {
      return (userId) => this.$store.getters['chat/chatLastMessaged'](userId)
    },
    chatUnseenMessages() {
      return (userId) => {
        const unseenMsg = this.$store.getters['chat/chatUnseenMessages'](userId)
        if (unseenMsg) return unseenMsg
      }
    },
    chatContacts() {
      return this.$store.getters['chat/chatContacts']
    },
    contacts() {
      return this.$store.getters['chat/contacts']
    },
    searchQuery: {
      get() {
        return this.$store.state.chat.chatSearchQuery
      },
      set(val) {
        this.$store.dispatch('chat/setChatSearchQuery', val)
      }
    },
    isActiveChatUser() {
      return (userId) => userId == this.activeChatUser
    },
    windowWidth() {
      return this.$store.state.windowWidth
    }
  },
  methods: {
    // setInputFocus(){
    //     if(window.getSelection().isCollapsed) this.$refs.msgInput.$refs.vsinput.focus()
    // },
    loadMoreMessages($state) {
        this.preventChatLogScroll = true
        this.$store.dispatch('chat/loadMoreMessages', {id: this.activeChatUser})
            .then((loadMore) => {
                loadMore ? $state.loaded() : $state.complete()
                this.preventChatLogScroll = false
            })
    },
    updateActiveChatUser(contactId) {
      this.activeChatUser = contactId
      if (this.$store.getters['chat/chatDataOfUser'](this.activeChatUser)) {
        this.$store.dispatch('chat/markSeenAllMessages', contactId)
      }
      let chatData = this.$store.getters['chat/chatDataOfUser'](this.activeChatUser)
      if (chatData) this.isChatPinned = chatData.isPinned
      else this.isChatPinned = false
      this.toggleChatSidebar()
      this.typedMessage = ''
    },
    sendMsg() {
      if (!this.typedMessage) return
      const payload = {
        isPinned: this.isChatPinned,
        'msg': {
          'textContent' : this.typedMessage,
          'time'        : String(this.$store.state.date),
          'isSent'      : true,
          'isSeen'      : false,
          'readAt'      : null,
          'status'      : 'sending',
        },
        'id': this.activeChatUser
      }
      this.$store.dispatch('chat/sendChatMessage', payload)
      this.typedMessage = ''
      this.$refs.chatLogPS.$el.scrollTop = this.$refs.chatLog.scrollHeight
    },
    resendMsg(msg){
        if(!msg) return
        const payload = { msg: msg, id: this.activeChatUser, resend: true }
        this.$store.dispatch('chat/sendChatMessage', payload)
    },
    toggleIsChatPinned(value) {
      this.isChatPinned = value
    },
    setSidebarWidth() {
      if (this.windowWidth < 1200) {
        this.isChatSidebarActive = this.clickNotClose = false
      } else {
        this.isChatSidebarActive = this.clickNotClose = true
      }
    },
    toggleChatSidebar(value = false) {
      if (!value && this.clickNotClose) return
      this.isChatSidebarActive = value
    },
  },
  components: {
    VuePerfectScrollbar,
    ChatContact,
    UserProfile,
    ChatNavbar,
    ChatLog,
    InfiniteLoading,
  },
  async created() {
    if(this.contacts.length === 0){
        await this.$store.dispatch('chat/fetchChatContacts')
    }
    const userId = this.$route.params.user_id
    if(userId) {
        this.$store.dispatch('chat/startChat', userId).then((contact) => {
            this.updateActiveChatUser(contact.id)
        })
    }
    this.setSidebarWidth()
  },
  beforeDestroy() {
      this.activeChatUser = null
  },
  mounted() {
    this.$store.dispatch("chat/setChatSearchQuery", "")
  },
}

</script>


<style lang="scss">
@import "@/assets/scss/vuexy/apps/chat.scss";
</style>
